// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__j_vUL","dragIcon":"SortableItem_dragIcon__T9ln2","disabled":"SortableItem_disabled__D6VJK"};